module.exports = __webpack_public_path__ + "static/media/Home_72dpi.79240ff9.png";